import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { useLocalSearchParams } from 'expo-router';
import JobsContext from '../context/JobsContext';
import ListJobs from '../components/ListJobs';
import AdBanner from '../components/AdBanner';
import { useThemePalette } from '../theme';

export const metadata = {
  title: 'Remote Jobs - Browse All Remote Job Opportunities | RemoteWork',
  description:
    'Explore thousands of remote job listings from companies worldwide. Find your ideal remote position in tech, marketing, design, and more.',
  keywords: 'remote jobs, remote work, job listings, telecommute jobs, work from home',
};

export default function JobsScreen() {
  const { data, refresh, refreshing, error } = useContext(JobsContext);
  const palette = useThemePalette();
  // Set when arriving from a saved alert's "matching now" tap.
  const { q } = useLocalSearchParams<{ q?: string }>();

  return (
    <View style={[styles.container, { backgroundColor: palette.canvas }]}>
      <ListJobs
        jobs={data}
        refresh={refresh}
        refreshing={refreshing}
        error={error}
        initialSearch={typeof q === 'string' ? q : undefined}
      />
      <AdBanner />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1 },
});
